import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthActions } from '../../shared/store/auth/auth.actions';
import { AuthToken } from '../../domain/auth/model/auth-token';
import { AuthSelectors } from '../../shared/store/auth/auth.selectors';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private refreshingToken: boolean = false;

  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(private store: Store) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (
          error instanceof HttpErrorResponse &&
          [401].includes(error.status)
        ) {
          if (this.refreshingToken) {
            return this.refreshTokenSubject.pipe(
              filter(result => result !== null),
              take(1),
              switchMap(() => next.handle(this.addAuthenticationToken(request)))
            );
          } else {
            this.refreshingToken = true;
            this.refreshTokenSubject.next(null);

            return this.store.dispatch(AuthActions.RefreshToken).pipe(
              switchMap(() => {
                this.refreshingToken = false;
                this.refreshTokenSubject.next(true);

                return next.handle(this.addAuthenticationToken(request));
              }),

              catchError(catchedError => {
                this.refreshingToken = false;
                this.refreshTokenSubject.next(true);

                return throwError(catchedError);
              })
            );
          }
        }

        return throwError(error);
      })
    );
  }

  private addAuthenticationToken(request: HttpRequest<unknown>) {
    const token: AuthToken | null = this.store.selectSnapshot(
      AuthSelectors.token
    );

    return !token
      ? request
      : request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token.accessToken,
          },
        });
  }
}
